import { postToDataLayer } from './googleDataLayer';

export const ADDED_APPLICANT_EMAIL_TO_USER_EVENT = 'addedApplicantEmailToUser';

export function trackApplicantEmail(applicantEmail?: string) {
  return postToDataLayer({
    event: ADDED_APPLICANT_EMAIL_TO_USER_EVENT,
    email: applicantEmail,
  });
}
